module.exports = __webpack_public_path__ + "static/media/SN.daa49c16.svg";